<script setup lang="ts">
type Props = {
  data: Record<string, unknown>
  theme: string | null | undefined
}

const { t } = useI18n()

// SectionsText props
const _props = defineProps<Props>()

// Get polygon data and compute dynamic numbers
const { data: speciesData } = await useSpeciesData(_props?.data?.polygon)

const infoItems = computed(() => {
  if (_props?.data?.useDynamicNumbers) {
    // Only show dynamic items if useDynamicNumbers is true
    return [
      ..._props?.data?.items,
      {
        info: speciesData.value?.allSpecies?.hydratedFacets.taxonId.totalCount.toLocaleString(
          'da-DK',
        ),
        suffix: '',
        title: t('label.area.discoveredSpecies'),
        _key: 1,
      },
      {
        info: speciesData.value?.redlistedSpecies?.hydratedFacets.taxonId.totalCount.toLocaleString(
          'da-DK',
        ),
        suffix: '',
        title: t('label.area.redlistedSpecies'),
        _key: 2,
      },
    ]
  } else {
    // Only show original items if useDynamicNumbers is false
    return _props?.data?.items
  }
})
</script>

<template>
  <div class="px-bleed relative w-full overflow-clip">
    <div class="grid gap-5 border-t border-(--theme-fg)/15 lg:gap-10">
      <div class="flex flex-col">
        <h2 class="mt-8 mb-5 text-sm font-bold uppercase lg:mb-18">{{ data.trumpet }}</h2>
        <h3 class="font-display text-xl lg:text-2xl">{{ data.title }}</h3>
      </div>
      <div class="lg:w-cols-5 lg:ml-push-6 w-full">
        <span v-if="data.content">
          <ElementsPortableTextWrapper :content="data.content" />
        </span>
        <div
          v-if="data?.callToAction?.length > 0"
          class="ctas lg:w-cols-5 mt-10 mb-10 flex w-full flex-col items-start gap-2.5"
        >
          <ElementsButton v-for="(cta, index) in data?.callToAction" :key="index" :link="cta" />
        </div>
      </div>

      <ElementsInformationItems :items="infoItems" />
    </div>
  </div>
</template>
